import * as React from 'react';
import { LoaderIcon } from '@mentimeter/ragnar-visuals';
import { Link } from '@mentimeter/ragnar-ui/link';
import { Text } from '@mentimeter/ragnar-ui/text';
import { MarkdownText } from '@mentimeter/slides-presentation-ui/text/markdown-text';

// TODO: translate
const GENERAL_MESSAGE =
  'We have issues connecting to the quiz. If the problem persists, contact [hello@mentimeter.com](mailto:hello@mentimeter.com).';

export const Loading = ({ onReload }: { onReload?: () => void }) => {
  const [longWait, setLongWait] = React.useState(false);
  React.useEffect(() => {
    const timer = setTimeout(() => {
      setLongWait(true);
    }, 5000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <LoaderIcon />
      {longWait && (
        <>
          <Text mt={3} textAlign="center" fontSize="125">
            <MarkdownText
              source={GENERAL_MESSAGE}
              disableLineBreaks={false}
              allowHyperlinks
            />
          </Text>
          {onReload && (
            <Link fontSize={2} mt={2} onClick={onReload}>
              Reload
            </Link>
          )}
        </>
      )}
    </>
  );
};
